import React from 'react'

import Backgrd from '../asset/images/hero-bg.jpg'

import Subtitle from '../common/Subtitle/Subtitle'

import {H1a} from '../common/H1/H1'
import { FigureHome } from '../common/Figure/Figure'
import avenirplus from '../asset/images/avenirplus.png'
import salle1 from '../asset/images/Salle 1 Avenir+.jpg'
import salle2 from '../asset/images/Salle 2 Avenir +.jpg'

function Home() {
	return (
		<section
			className="hero"
			id="home"
			style={{ backgroundImage: `url(${Backgrd})` }}
		>
			<>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						textAlign: 'center',
						marginBlockEnd: '20px',
					}}
				>
					<H1a style={{ fontSize: '9rem' }}>Avenir +</H1a>
					<Subtitle style={{ width:"80%", margin:"0 auto",marginBlockStart: '20px',marginBlockEnd:'20px'}}>
						développer ses capacités - Progresser - S'épanouir
					</Subtitle>
					<FigureHome style={{ marginBlockStart: '50px',marginBlockEnd: '100px' }}>
					<img
							src={salle1}
							width="200"
							height="200"
							aria-hidden="true"
							alt="salle1"
							className="abs-img abs-img-2"
						/>
						<img
							src={avenirplus}
							alt="logo"
							className="w-100"
							style={{
								margin:"0 auto",
								marginBlockEnd: '100px',
							}}
						/>

						<img
							src={salle2}
							width="200"
							height="200"
							aria-hidden="true"
							alt="salle2"
							className="abs-img abs-img-3"
						/>
					</FigureHome>
				</div>
			</>

		</section>
	)
}
export default Home
